// eslint-disable-next-line @typescript-eslint/no-empty-function
function NoOp() {}

export default NoOp
